import React, {Component} from 'react';
import {Input} from "reactstrap";
import {ChannelLogo} from "../channels/ChannelLogo";

export class MultiSelectAdAccountItem extends Component {
    constructor(props) {
        super(props);

        this.handleOnChange = this.handleOnChange.bind(this);
    }


    handleOnChange(event) {
        if(this.props.readOnly){
            return;
        }

        this.props.onChange(event)
    }

    renderCheckedClass() {
        return this.props.checked ? "checked" : "";
    }

    render() {
        return (
            <li key={`li-${this.props.itemId}`}>
                <label className={`multi-select-item -${this.props.channel.toLowerCase()} ${this.renderCheckedClass()}`}>
                    <Input type="checkbox" onChange={this.handleOnChange}
                           checked={this.props.checked}
                           name={this.props.accountName}
                           data-id={this.props.itemId}
                           readOnly={this.props.readOnly}
                    />
                    <div className="multi-select-item-name"><span className="logo"><ChannelLogo useOld={false}
                                                                         marginLeft={0}
                                                                         padding={0}
                                                                         width={20}
                                                                         height={20}
                                                                         hspace={0} vspace={0}
                                                                         channel={this.props.channel}/></span>{`${this.props.accountName} (Id: ${this.props.accountId})`}</div>
                </label>
            </li>
        )
    }
}
